<template>
  <div>
    <div class="all-work__form">
      <div class="all-work__inside">
        <div class="all-work__blocks">
          <h1>{{ $t('message.Artists') }}</h1>
        </div>

        <div class="all-work__boxes">
          <div class="all-work__filter">
            <div class="all-artists-filter__item">
              <sort-artists-type-sub/>
            </div>
          </div>

          <filter-search-sub/>
        </div>
      </div>
    </div>

    <div class="all-work__contents" id="id_main_works_list" v-show="artistsTotal>0 || !is_empty_filters || artistsLoading">
      <artists-filter-sub
        :filters="filters"
        v-on:filterChanged="filterChanged"
      ></artists-filter-sub>

      <div>
        <works-tags-sub/>

        <div v-show="artistsLoading" style="margin-top: 40px">
          <preloader url="/action/preloader/artist4"/>
        </div>

        <div class="artists-filter__result">
          <div class="works-list-l artists-painter__section">
            <div class="works-list__container">

              <artists-list-sub v-show="!artistsLoading"/>
              <artists-pagination-sub v-show="!artistsLoading"/>

            </div>
          </div>
        </div>


      </div>
    </div>

    <div v-show="artistsTotal==0 && !artistsLoading && is_empty_filters">
      <div class="limiter" style="margin-top: 20px; margin-bottom: 35px">

        <div class="placeholder-box">
          <div class="placeholder-image">
            <img :src="plceholder_src" style="width: 361px"/>
          </div>

          <div class="placeholder-text">
            {{ $t('message.NothingHereYet') }}
          </div>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
  import WorksTagsSub from "./list/WorksTagsSub";
  import ArtistsListSub from "./list/ArtistsListSub";

  import Preloader from "../../../components/Preloader";//+
  import ArtistsComputedMix from "../../../components/ArtistsComputedMix";
  import ArtistsMix from "../../../components/ArtistsMix";
  import ArtistsPaginationSub from "./list/ArtistsPaginationSub";
  import ArtistsFilterSub from "./list/ArtistsFilterSub";
  import SortArtistsTypeSub from "../../_common/components/list/filter/SortArtistsTypeSub";
  import FilterSearchSub from "../../_common/components/list/filter/FilterSearchSub";

  export default {
    name: 'artistssub',
    props: [ 'filter' ],
    components: {
      SortArtistsTypeSub,
      ArtistsFilterSub,
      ArtistsPaginationSub,
      ArtistsListSub,
      WorksTagsSub,
      FilterSearchSub,

      Preloader
    },
    mixins: [ArtistsComputedMix, ArtistsMix],

    data() {
      return {
        is_show_filter: false,
      }
    },

    watch: {
      $route(to, from) {
        if ( !this.$store.getters.artistsLoading ) this.$store.dispatch('setFilters', {}).then(()=>{});
      }
    },

    computed: {
      plceholder_src(){
        return window._GL_SITE_URL_CDN+'/res7/img/placeholders/collection.svg';
      },

      get_filter_class: {
        get () {
          return this.is_show_filter?'show_filter':'hide_filter';
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/sub/air_light/components/ArtistsSub.vue